import { useCallback } from 'react';

import { useContentTreeSelection } from '@confluence/content-tree-actions';

import { usePageTreeActions } from '../usePageTreeState';

import { transformToPrimaryActionInput } from './data-transformers';

// Primary actions include archive and delete
export const usePrimaryButtons = () => {
	const [{ selectedContent }] = useContentTreeSelection();

	const { getState } = usePageTreeActions();

	const getPrimaryActionInput = useCallback(() => {
		const { rootId, pages, contentIdsWithLoadedChildren } = getState();

		const selectedContentCopy = { ...selectedContent };
		return transformToPrimaryActionInput(
			pages[rootId],
			pages,
			contentIdsWithLoadedChildren,
			selectedContentCopy,
		);
	}, [getState, selectedContent]);

	const getCurrentSpace = useCallback(() => {
		const { spaceKey, spaceId } = getState();
		return { spaceKey, spaceId };
	}, [getState]);

	return {
		getPrimaryActionInput,
		getCurrentSpace,
	};
};
